export interface IDebugState {
    devTab?: number;
    panelShow?: boolean;
    activeTab?: ITabNames;
    appVersion?: any;
    visible?: boolean;
}

export enum ITabNames {
    INFO = 'INFO',
    TEST = 'TEST'
}
